"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireBrevoTemplateId = exports.isSystemEmailTemplateName = exports.SYSTEM_EMAIL_TEMPLATE_NAMES = exports.EmailTemplateSchema = exports.EmailTemplatePortalUpdateSchema = exports.EmailTemplateSenderUpdateSchema = exports.EMAIL_SENDER_NAME_MAX_LENGTH = exports.EmailTemplateBaseSchema = exports.EmailTemplateDeliverySchema = void 0;
var z = __importStar(require("zod"));
var EmailDocument_1 = require("./EmailDocument");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.EmailTemplateDeliverySchema = z.enum(['brevo', 'portal']);
exports.EmailTemplateBaseSchema = z.object({
    // Coerce: HTML number inputs and some JSON clients send templateId as string. Omitted on portal-only rows.
    templateId: z.coerce.number().int().min(1, { message: 'Template ID must be a positive integer' }).optional(),
    templateName: z.string().min(3, { message: 'Description must be at least 3 characters' }),
    /** Omitted on legacy rows — treated as Brevo template id delivery. */
    delivery: exports.EmailTemplateDeliverySchema.optional(),
    subject: z.string().optional(),
    body: z.string().optional(),
    /** Omitted on rows saved before the rich editor — the body is legacy plain text. */
    bodyFormat: EmailDocument_1.EmailBodyFormatSchema.optional(),
    /** Empty means the environment default sender (FROM / PORTAL_FROM). */
    senderEmail: z.string().optional(),
    senderName: z.string().optional(),
});
/** Brevo rejects sender names longer than this. */
exports.EMAIL_SENDER_NAME_MAX_LENGTH = 70;
exports.EmailTemplateSenderUpdateSchema = z.object({
    senderEmail: z
        .string()
        .trim()
        .toLowerCase()
        .refine(function (v) { return v === '' || z.string().email().safeParse(v).success; }, { message: 'Sender email is invalid' })
        .optional(),
    senderName: z
        .string()
        .trim()
        .max(exports.EMAIL_SENDER_NAME_MAX_LENGTH, {
        message: "Sender name must be at most ".concat(exports.EMAIL_SENDER_NAME_MAX_LENGTH, " characters"),
    })
        .refine(function (v) { return !/[\r\n<>"]/.test(v); }, { message: 'Sender name contains invalid characters' })
        .optional(),
});
exports.EmailTemplatePortalUpdateSchema = z.object({
    subject: z.string().min(1, { message: 'Subject is required' }),
    body: z.string().min(1, { message: 'Body is required' }).max(EmailDocument_1.EMAIL_BODY_MAX_LENGTH, { message: 'Body is too long' }),
    bodyFormat: EmailDocument_1.EmailBodyFormatSchema.optional(),
});
exports.EmailTemplateSchema = exports.EmailTemplateBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
/** Descriptions reserved for code-driven sends (must match API TemplateName enum values). */
exports.SYSTEM_EMAIL_TEMPLATE_NAMES = [
    'Verification code',
    'Reset Password Request',
    'Membership Renewal Due Soon',
    'Your membership has expired',
    'Document Expiry',
    'Re Join Now',
    'Payment Confirmation Email',
    'Sea Service Testimonial Reminder',
    'Your membership renews/expires today',
    'No profile photo',
    'Upload a profile photo',
    'Upload new Passport',
    'Upload Passport',
    'Signatory Token',
    'Welcome Non Member',
    'Request Approved',
    'Pending Approval',
    'Pending Validation',
    'Signatory Reject',
    'Admin SRB Reject',
    'Signatory Data Changed',
    'Request Approved Non Member',
    'Payment Reminder',
    'Chase for Payment',
    'Non Member Payment Reminder',
    'Non Member Chase for Payment',
    'Account Deletion Status Update',
    'Account Deletion Soft Deleted',
    'Account Hard Deleted',
    'Hard Deletion Notification',
    'Clarification Email to Members',
    'Document Status Update',
    'Signatory Reminder',
    'Member Signatory Escalation',
];
var isSystemEmailTemplateName = function (templateName) {
    return exports.SYSTEM_EMAIL_TEMPLATE_NAMES.includes(templateName);
};
exports.isSystemEmailTemplateName = isSystemEmailTemplateName;
var requireBrevoTemplateId = function (template) {
    var id = template.templateId;
    if (id === undefined || !Number.isInteger(id) || id < 1) {
        throw new Error("Email template \"".concat(template.templateName, "\" has no Brevo templateId"));
    }
    return id;
};
exports.requireBrevoTemplateId = requireBrevoTemplateId;
//# sourceMappingURL=EmailTemplate.js.map